import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

export const Slide7 = ({ t, total, onActive }) => {
  return (
    <SlideShell index={6} total={total} onActive={onActive} label="Flywheel">
      {/* Background Collage Layer */}
      <div className="absolute inset-0 z-0 bg-[#0a0a0a] overflow-hidden pointer-events-none">
        {/* Top-Left: Dining */}
        <div 
          className="absolute top-0 left-0 w-[70%] h-[80%] opacity-70"
          style={{
            backgroundImage: "url('/images/s7-dining.png')",
            backgroundSize: "cover",
            backgroundPosition: "top left",
            maskImage: "radial-gradient(ellipse at top left, black 20%, transparent 70%)",
            WebkitMaskImage: "radial-gradient(ellipse at top left, black 20%, transparent 70%)"
          }}
        />
        
        {/* Bottom-Left: Wine Glasses */}
        <div 
          className="absolute bottom-0 left-0 w-[50%] h-[60%] opacity-80"
          style={{
            backgroundImage: "url('/images/s7-glasses.png')",
            backgroundSize: "cover",
            backgroundPosition: "bottom left",
            maskImage: "radial-gradient(ellipse at bottom left, black 20%, transparent 70%)",
            WebkitMaskImage: "radial-gradient(ellipse at bottom left, black 20%, transparent 70%)"
          }}
        />

        {/* Bottom-Right: Vineyard */}
        <div 
          className="absolute bottom-0 right-0 w-[55%] h-[65%] opacity-70"
          style={{
            backgroundImage: "url('/images/s7-vineyard.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "bottom right",
            maskImage: "radial-gradient(ellipse at bottom right, black 20%, transparent 70%)",
            WebkitMaskImage: "radial-gradient(ellipse at bottom right, black 20%, transparent 70%)"
          }}
        />
      </div>

      {/* Dimming overlay to ensure text legibility */}
      <div className="absolute inset-0 z-0 bg-black/40 pointer-events-none" />

      <div className="relative z-10 w-full max-w-7xl px-6 md:px-12">
        <div className="overline mb-8">{t.overline}</div>
        <div className="text-center mb-14">
          <h2 className="font-display font-medium text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tighter">
            {t.heading}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {t.loops.map((loop, i) => (
            <div
              key={i}
              className="glass lift rounded-2xl p-8 relative overflow-hidden group"
              data-testid={`s7-loop-${i}`}
            >
              <div className="absolute -top-8 -right-8 w-40 h-40 rounded-full bg-[var(--ph-accent-glow)] blur-3xl opacity-30 group-hover:opacity-70 transition-opacity" />
              <div className="relative">
                <div className="flex items-baseline justify-between mb-6">
                  <span className="font-mono text-xs tracking-widest text-[var(--ph-accent)]">
                    LOOP 0{i + 1}
                  </span>
                  <span className="font-display text-5xl text-white/10">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="font-display text-3xl md:text-4xl mb-4 leading-tight">
                  {loop.t}
                </div>
                <p className="text-base text-neutral-400 leading-relaxed">{loop.d}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-block glass rounded-full px-6 py-3">
            <span className="font-mono text-[10px] tracking-widest text-[var(--ph-accent)] mr-3">
              KEY
            </span>
            <span className="text-sm text-neutral-300 italic">"{t.pull}"</span>
          </div>
        </div>
      </div>
    </SlideShell>
  );
};


